import request from '@/utils/request'

// 获取班级分类树
export function getClassCategoryTree() {
  return request({
    url: '/api/edu/class-category/tree',
    method: 'get'
  })
}

// 获取班级列表
// GET /api/frontend/class/list
// 参数:
// - categoryId: 分类ID (可选)
// - className: 班级名称 (可选)
// - pageNum: 页码 (可选)
// - pageSize: 每页数量 (可选)
// 返回: {
//   code: 200,
//   data: {
//     list: [班级列表],
//     total: 总数
//   },
//   message: "success"
// }
export function getClassList(params) {
  return request({
    url: '/api/frontend/class/list',
    method: 'get',
    params
  })
}

// 获取班级详情
// GET /api/frontend/class/{id}
// 参数:
// - id: 班级ID (路径参数)
// 返回: {
//   code: 200,
//   data: {
//     id: 0,
//     className: "",
//     subtitle: "",
//     coverImage: "",
//     introduction: "",
//     price: 0,
//     originalPrice: 0,
//     validityDays: 0,
//     categoryId: 0,
//     categoryName: "",
//     forceCompleteCourse: 0,
//     finalExamId: 0,
//     finalExamName: "",
//     finalPassScore: 0,
//     enableCertificate: 0,
//     courses: [...],
//     papers: [...],
//     courseCount: 0,
//     paperCount: 0,
//     salesCount: 0,
//     viewCount: 0
//   },
//   message: "success"
// }
export function getClassDetail(id) {
  return request({
    url: `/api/frontend/class/${id}`,
    method: 'get'
  })
}

// 购买班级
// POST /api/frontend/class/{id}/purchase
// 参数:
// - id: 班级ID (路径参数)
// - payType: 支付方式 (1: 微信, 2: 支付宝)
// - couponId: 优惠券ID (可选)
// 返回: {
//   code: 200,
//   data: 订单ID,
//   message: "下单成功"
// }
export function purchaseClass(id, params) {
  return request({
    url: `/api/frontend/class/${id}/purchase`,
    method: 'post',
    params
  })
}

// 获取我的班级列表
// GET /api/frontend/class/my
// 参数:
// - pageNum: 页码 (可选)
// - pageSize: 每页数量 (可选)
// 返回: {
//   code: 200,
//   data: {
//     list: [订单列表],
//     total: 总数
//   },
//   message: "success"
// }
export function getMyClassList(params) {
  return request({
    url: '/api/frontend/class/my',
    method: 'get',
    params
  })
}

// 获取班级学习进度
// GET /api/frontend/class/{id}/progress
// 参数:
// - id: 班级ID (路径参数)
// 返回: {
//   code: 200,
//   data: {
//     id: 0,
//     className: "",
//     courses: [...],
//     papers: [...],
//     courseProgress: 0,
//     finalExamStatus: 0,
//     finalExamScore: 0,
//     certificateStatus: 0,
//     certificateNo: ""
//   },
//   message: "success"
// }
export function getClassProgress(id) {
  return request({
    url: `/api/frontend/class/${id}/progress`,
    method: 'get'
  })
}

// 检查是否可以参加结业考试
// GET /api/frontend/class/{id}/can-take-exam
// 参数:
// - id: 班级ID (路径参数)
// 返回: {
//   code: 200,
//   data: true/false,
//   message: "success"
// }
export function canTakeFinalExam(id) {
  return request({
    url: `/api/frontend/class/${id}/can-take-exam`,
    method: 'get'
  })
}

// 获取班级学习详情（学习进度、考试记录、毕业状态）
export function getClassStudyDetail(id) {
  return request({
    url: `/api/frontend/class/${id}/study-detail`,
    method: 'get'
  })
}
